import { render, staticRenderFns } from "./CreateQrCode.vue?vue&type=template&id=5c0d5eb2"
import script from "./CreateQrCode.vue?vue&type=script&lang=js"
export * from "./CreateQrCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c0d5eb2')) {
      api.createRecord('5c0d5eb2', component.options)
    } else {
      api.reload('5c0d5eb2', component.options)
    }
    module.hot.accept("./CreateQrCode.vue?vue&type=template&id=5c0d5eb2", function () {
      api.rerender('5c0d5eb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/components/CreateQrCode.vue"
export default component.exports